import { trackStructuredEvent } from "./TrackingUtil";
import { CompulsoryTrackingTags, TrackingTags } from "../tracking/Tracking";

export function trackSelectBundle(
    bettyBundleId: string,
    compulsoryTrackingTags: CompulsoryTrackingTags,
    optionalTrackingTags?: Partial<TrackingTags>
) {
    const optionalTrackingTagsSanitized = optionalTrackingTags || {};
    const compulsoryTrackingTagsSanitized = compulsoryTrackingTags || {};
    const tags: Partial<TrackingTags> = Object.assign(
        {},
        {
            ...optionalTrackingTagsSanitized,
            ...compulsoryTrackingTagsSanitized,
            bettyBundleId
        }
    );
    trackStructuredEvent("article.selectBundle", { tags: tags });
}
